export interface HeaderSlide {
  id: number;
  title?: string;
  description?: string;
  image?: string;
  img?: string;
}

const headerSlides: HeaderSlide[] = [
  {
    id: 1,
    img: '/home/assets/img/head_slide1.jpg',
    title: 'CRAFTING VISIONS IN METAL',
    description: 'Precision Fabrication for Architects, Designers, & Custom Builders'
  }
];

export default headerSlides;
